import { fromEvent, map, tap } from "rxjs";

class Select {
    constructor(element){
        this.options = Array.from(element.options);
        this.select$ = fromEvent(element, "change").pipe(
            map((event) => event.target.value),
            tap((value) => {
                this.options.forEach(option => {
                    option.toggleAttribute("selected", option.value === value);
                });
            }),
        );
    }

    getObservable(){
        return this.select$;
    }
}

export default Select;